module.exports = __webpack_public_path__ + "assets/img/partner4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner4.png
// module id = 1969
// module chunks = 0